import { sirenActions, entityStore } from '~/utility/BinSentry-ui-utility';
import { LitEntity, html, css, renderIf } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../change-user-role-modal';
import '../../common/bn-icon';

class UserPermissionsTable extends LitEntity {
  static get properties() {
    return {
      userEnrollments: { type: Object, attribute: false },
      selectedEnrollment: { type: Object, attribute: false },
      showModal: { type: Boolean, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      button {
        color: var(--gray-60);
        cursor: pointer;
      }
      button:hover {
        color: var(--gray-80);
      }
      th {
        background: none;
        color: var(--gray-60);
        font-weight: normal;
        border: 0;
      }
      td {
        border-width: 1px 0 0 0;
      }
      table {
        border-radius: 3px;
        border-collapse: unset;
        border-spacing: 0;
      }
      .change-role-button {
        margin-left: 1em;
      }
    `];
  }

  render() {
    if (this.loading) {
      return html`<bn-loading></bn-loading>`;
    }

    const userEnrollmentsHref = this.entity?.getSubEntity('https://api.binsentry.com/rel/user-enrollments').href;
    return html`
      <lit-entity href="${userEnrollmentsHref}" @update="${this._onUserEnrollmentsUpdate}"></lit-entity>

      <change-user-role-modal
        .href="${this.getHref('self', this.selectedEnrollment)}"
        ?hide="${!this.showModal}"
        @user-role-changed="${this._onUserRoleChanged}"
        @close="${() => this.showModal = false}">
      </change-user-role-modal>

      ${renderIf(!this.userEnrollments, () => html`<bn-loading></bn-loading>`)}
      ${renderIf(this.userEnrollments, () => html`
        <table>
          <thead><tr><th>Organization</th><th>Role</th><th></th></tr></thead>
          <tbody>
            ${this.userEnrollments.getSubEntities('https://api.binsentry.com/rel/user-enrollment').map(this._renderEnrollment.bind(this))}
          </tbody>
        </table>
      `)}
    `;
  }

  _renderEnrollment(enrollment) {
    const organization = enrollment.getSubEntity('https://api.binsentry.com/rel/organization');
    const role = enrollment.getSubEntity('https://api.binsentry.com/rel/role');
    return html`
      <tr>
        <td>${organization.properties.name}</td>
        <td>
          ${role.properties.displayName}
          <button class="button--plain change-role-button" @click="${() => this._changeRole(enrollment)}">Change Role</button>
        </td>
        <td>
          ${renderIf(enrollment.getAction('delete-enrollment'), () => html`
            <button class="button--plain" @click="${() => this._deleteEnrollment(enrollment)}">
              <bn-icon name="fas fa-times"></bn-icon>
            </button>
          `)}
        </td>
      </tr>
    `;
  }

  async _changeRole(enrollment) {
    this.selectedEnrollment = enrollment;
    this.showModal = true;
  }

  async _deleteEnrollment(enrollment) {
    if (window.confirm('Are you sure you want to remove this permission')) {
      await sirenActions.submitAction(enrollment.getAction('delete-enrollment'));
      entityStore.invalidateHref(this.userEnrollments.getLink('self').href);
      this.dispatchEvent(new CustomEvent('user-role-deleted', { bubbles: true, composed: true }));
    }
  }

  _onUserEnrollmentsUpdate(e) {
    this.userEnrollments = e.detail.entity;
  }

  _onUserRoleChanged() {
    entityStore.invalidateHref(this.getHref('self', this.userEnrollments));
  }
}

window.customElements.define('user-permissions-table', UserPermissionsTable);
